function getOrderOnlineLink(title) {
  const linkMap = {
    "supreme-pizza-millwoods-edmonton-5135": "https://orders.supremepizzaonline.ca/supreme-pizza-millwoods-edmonton-5135",
    "supreme-pizza-knottwood-edmonton-5136": "https://orders.supremepizzaonline.ca/supreme-pizza-knottwood-edmonton-5136",
    "supreme-pizza-chappelle-edmonton-5134": "https://orders.supremepizzaonline.ca/supreme-pizza-chappelle-edmonton-5134",
    "supreme-pizza-beaumont-beaumont-5271": "https://orders.supremepizzaonline.ca/supreme-pizza-beaumont-beaumont-5271/",
  };

  return linkMap[title] || "N/A";
}

const storeDetails = {
  status: "success",
  data: {
    restaurants: [

      //1. Supreme Pizza — Mill Woods
      {
        profile: {
          id: 5135,
          restaurant_name: "Supreme Pizza — Mill Woods",
          title: "supreme-pizza-millwoods-edmonton-5135",
          address: "4267 23 Ave NW, Edmonton, AB T6L 5Z8, Canada",
          phone: "+1 (780) 485-1213",
          available_days: [
            { id: 51351, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 51352, day: "MONDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 51353, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 51354, day: "TUESDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 51355, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 51356, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 51357, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 51358, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 51359, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 513510, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 513511, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 513512, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 513513, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 513514, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "53.45492292219206",
          lng: "-113.40793886302345",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //2. Supreme Pizza — Knottwood
      {
        profile: {
          id: 5136,
          restaurant_name: "Supreme Pizza — Knottwood",
          title: "supreme-pizza-knottwood-edmonton-5136",
          address: "1079 Knottwood Rd E, Edmonton, AB T6K 3N5, Canada",
          phone: "+1 (780) 485-1213",
          available_days: [
            { id: 51361, day: "SUNDAY", opening_time: "14:00:00", closing_time: "22:00:00", order_mode: 1 },
            { id: 51362, day: "MONDAY", opening_time: "14:00:00", closing_time: "22:00:00", order_mode: 1 },
            { id: 51363, day: "TUESDAY", opening_time: "14:00:00", closing_time: "22:00:00", order_mode: 1 },
            { id: 51364, day: "WEDNESDAY", opening_time: "14:00:00", closing_time: "22:00:00", order_mode: 1 },
            { id: 51365, day: "THURSDAY", opening_time: "14:00:00", closing_time: "22:00:00", order_mode: 1 },
            { id: 51366, day: "FRIDAY", opening_time: "14:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 51367, day: "SATURDAY", opening_time: "14:00:00", closing_time: "24:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "53.44497742476939",
          lng: "-113.44405068562949",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //3. Supreme Pizza — Chappelle (Heritage Valley)
      {
        profile: {
          id: 5134,
          restaurant_name: "Supreme Pizza — Chappelle",
          title: "supreme-pizza-chappelle-edmonton-5134",
          address: "6469 Cartmell Pl SW, Edmonton, AB T6W 1Z1, Canada",
          phone: "+1 (780) 485-1213",
          available_days: [
            { id: 51341, day: "SUNDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
            { id: 51342, day: "MONDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
            { id: 51343, day: "TUESDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
            { id: 51344, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
            { id: 51345, day: "THURSDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
            { id: 51346, day: "FRIDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
            { id: 51347, day: "SATURDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "53.3962611560526",
          lng: "-113.57109613206791",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //4. Supreme Pizza — Beaumont
      {
        profile: {
          id: 5271,
          restaurant_name: "Supreme Pizza — Beaumont",
          title: "supreme-pizza-beaumont-beaumont-5271",
          address: "4904 30 Ave #104, Beaumont, AB T4X 1S6, Canada",
          phone: "+1 (780) 485-1213",
          available_days: [
            { id: 52711, day: "SUNDAY", opening_time: "11:00:00", closing_time: "22:00:00", order_mode: 1 },
            { id: 52712, day: "MONDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
            { id: 52713, day: "TUESDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
            { id: 52714, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
            { id: 52715, day: "THURSDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
            { id: 52716, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 52717, day: "SATURDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 52718, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 52719, day: "SUNDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "53.34073978767116",
          lng: "-113.41327220123476",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //5. Supreme Pizza — Northside (Coming Soon)
      {
        profile: {
          id: 5300,
          restaurant_name: "Supreme Pizza — Northside",
          title: "supreme-pizza-northside-edmonton",
          address: "Unit 2, 3341 153 Ave NW, Edmonton, AB T5Y 6A6, Canada",
          phone: "+1 (780) 485-1213",
          available_days: [],
          close_restaurent: true,
          skip_live_check: true,
          lat: "53.61492060105306",
          lng: "-113.3921747303539",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },

    ],
  },
  message: "successful response",
};

export default storeDetails;
